import { Divider } from "@material-ui/core";
import { FC, ReactNode, useEffect, useState } from "react";
import { BOLETO } from "src/constants";
import { StringUtil } from "src/framework/commons/StringUtil";
import { FullWidthButton } from "src/framework/components/buttons";
import { InputMoney } from "src/framework/components/forms";
import { useObservable } from "src/framework/store/storeUtil";
import { formasPagamentoTextoInformativo$ } from "src/store/global.store";


interface PixProperties {
    onChangeValue?: (value: any) => void
    disabled?: boolean;
    valor?: any;
    label?: ReactNode;
    sizes?: string;
}

const Pix: FC<PixProperties> = ({
    valor,
    disabled,
    sizes,
    label = "Valor a pagar",
    onChangeValue,
}) => {
    const [valorPix, setValorPix] = useState<number>(0);
    const textoInformativo = useObservable(formasPagamentoTextoInformativo$);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        if (textoInformativo) {
            setTexto(StringUtil.retornaTextoInformativo(textoInformativo.data, BOLETO.id));
        }
    }, [textoInformativo])

    useEffect(() => {
        setValorPix(Number(Number(valor).toFixed(2)))
    }, [valor]);

    return <>
        <div className="row">
            <div className="X12">
                <p style={{ textAlign: "left" }}>{texto}</p>
            </div>
        </div>
        <div className="row X--middle">
            <div className={sizes}>
                <InputMoney
                    label={label}
                    disabled={disabled}
                    name="valor-pix"
                    value={valorPix}
                    defaultValue={valorPix}
                    onChangeValue={(newValue) => {
                        const _value = newValue.numberValue
                        
                        if (onChangeValue) {
                            onChangeValue(_value);
                            setValorPix(Number(_value));
                        }
                    }}
                    onBlur={(event: any) => {
                        let _valor: number = Number(Number(String(event?.target?.value || "0,00")?.replace(/\./g, "")?.replace(/\,/g, ".")).toFixed(2)); 
                        if (_valor && _valor > valor) {
                            _valor = valor;
                        }
                        setValorPix(Number(_valor))
                    }}

                />
            </div>
        </div>
    </>
}

export { Pix }